import { useEffect } from 'react';
import { AppointmentData, Business } from '../types';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { showNotification } from '@/utils/notificationUtils';
import Utils from '@/utils/util';
import { ReactComponent as GroomingIcon } from '@/assets/img/grooming.svg';
import { ReactComponent as BoardingIcon } from '@/assets/img/boarding.svg';
import { ReactComponent as DayCareIcon } from '@/assets/img/day-care.svg';
import { ReactComponent as SelectedGroomingIcon } from '@/assets/img/grooming-selected.svg';
import { ReactComponent as SelectedBoardingIcon } from '@/assets/img/boarding-selected.svg';
import { ReactComponent as SelectedDayCareIcon } from '@/assets/img/day-care-selected.svg';
import './ServiceTypeSelection.scss';
import { useTranslation } from 'react-i18next';

export type ServiceTypeSelectionProps = {
  business?: Business;
  appointmentData?: AppointmentData;
  onChange: (appointmentData: AppointmentData) => void;
  next: (hasAddons: boolean) => void;
};

export const ServiceTypeSelection = ({
  business,
  appointmentData,
  onChange,
  next,
}: ServiceTypeSelectionProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    Utils.scrollToTop();
  }, []);
 
  const onServiceTypeClick = (serviceType: string) => {
    if (appointmentData) {
      if(!appointmentData.selectedLocation) {
         showNotification({
            type: 'error',
            title: "Please select location to proceed",
          });
          return;
      }
      appointmentData.selectedServiceType = serviceType;
      onChange(appointmentData);
      next(false);
    }
  };
  return (
    <div className="service-type-selection">
      <div>
        <PetskedTitle
          title={t("Hey,")}
          highlightTitle={t("Welcome !")}
          size="lg"
          alignText="left"
          description={t("What'd you like to have for your furry mate today?")}
        />
        <div className="details-select">
          <ul>
            {business?.offerings?.grooming === true && <li
              className={
                appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING
                  ? 'selected'
                  : ''
              }
              onClick={() => onServiceTypeClick(Utils.SERVICE_TYPES.GROOMING)}
            >
              <div>
                <GroomingIcon className="service-type-icon" />
                <SelectedGroomingIcon className="selected-service-type-icon" />
                <span>
                  <h5>{t('Grooming')}</h5>
                  <p>{t('For your pet')}&apos;s {t('quality care services')}</p>
                </span>
              </div>
              <p>{t('For your pet')}&apos;s {t('quality care services')}</p>
            </li>}
            {business?.offerings?.daycare === true && 
            <li
              className={
                appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE
                  ? 'selected'
                  : ''
              }
              onClick={() => onServiceTypeClick(Utils.SERVICE_TYPES.DAY_CARE)}
            >
              <div>
                <DayCareIcon className="service-type-icon" />
                <SelectedDayCareIcon className="selected-service-type-icon" />
                <span>
                  <h5>{t('Daycare')}</h5>
                  <p>{t('For your pet')}&apos;s {t('playful second home')}</p>
                </span>
              </div>
              <p>{t('For your pet')}&apos;s {t('playful second home')}</p>
            </li>
            }
            {business?.offerings?.boarding === true &&
            <li
              className={
                appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING
                  ? 'selected'
                  : ''
              }
              onClick={() => onServiceTypeClick(Utils.SERVICE_TYPES.BOARDING)}
            >
              <div>
                <BoardingIcon className="service-type-icon" />
                <SelectedBoardingIcon className="selected-service-type-icon" />
                <span>
                  <h5>{t('Boarding')}</h5>
                  <p>{t('For your pet')}&apos;s {t('comfort while you')}&apos;{t('re away')}</p>
                </span>
              </div>
              <p>{t('For your pet')}&apos;s {t('comfort while you')}&apos;{t('re away')}</p>
            </li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

ServiceTypeSelection.displayName = 'ServiceTypeSelection';
